// 导出主库
import axios from './axios'

// 导出类型定义 导出给外面的应用使用。
export * from './types'

export default axios
